export function SummaryIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <g id="Vector">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13 7.5V3.5H14V7.5C14 8.32842 14.6716 9 15.5 9H19.5V10H15.5C14.1193 10 13 8.88071 13 7.5Z"
            fill="#2D70E2"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19 9.32842C19 8.9306 18.842 8.54907 18.5607 8.26777L14.7322 4.43934C14.4509 4.15803 14.0694 4 13.6716 4L7.5 4.00002C6.67157 4.00002 6 4.67159 6 5.50001V19.5C6 20.3284 6.67157 21 7.5 21H17.5C18.3284 21 19 20.3284 19 19.5V9.32842ZM19.2678 7.56066C19.7366 8.0295 20 8.66538 20 9.32842V19.5C20 20.8807 18.8807 22 17.5 22H7.5C6.11929 22 5 20.8807 5 19.5V5.50001C5 4.1193 6.11928 3.00002 7.49999 3.00002L13.6716 3C14.3346 3 14.9705 3.26339 15.4393 3.73223L19.2678 7.56066Z"
            fill="#2D70E2"
          />
        </g>
      </g>
    </svg>
  );
}

export function LightningIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="_Path_ (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.9469 2.88303C13.9469 2.88307 13.9463 2.88384 13.9452 2.88522C13.9463 2.88369 13.9469 2.883 13.9469 2.88303ZM13.2179 2.67948C13.2179 2.67947 13.218 2.6801 13.2181 2.68144ZM13.2185 3.9891L7.28593 13.0037H10.8669C11.3779 13.0037 11.7815 13.4227 11.7815 13.912V19.0122L17.7141 9.9976H14.1331C13.6221 9.9976 13.2185 9.57856 13.2185 9.08925V3.9891ZM11.0531 20.1182C11.0531 20.1182 11.0537 20.1174 11.0548 20.116C11.0537 20.1176 11.0531 20.1183 11.0531 20.1182ZM11.7819 20.3198C11.7821 20.3211 11.7821 20.3217 11.7821 20.3218ZM14.1975 2.39943C14.234 2.50418 14.2422 2.61013 14.2422 2.69505V8.9976H18.2489C18.4607 8.9976 18.7647 9.07279 18.9214 9.36186C19.0758 9.64681 18.974 9.93245 18.8613 10.1037L11.9212 20.6492C11.875 20.7193 11.8086 20.8053 11.7167 20.8744C11.6335 20.9369 11.4318 21.0543 11.1775 20.9743C10.9297 20.8963 10.8344 20.6934 10.8025 20.6018C10.766 20.4971 10.7578 20.3911 10.7578 20.3062V14.0037H6.7511C6.53927 14.0037 6.23533 13.9285 6.07863 13.6394C5.92416 13.3544 6.02604 13.0688 6.13873 12.8976L13.0788 2.35202C13.125 2.28192 13.1914 2.19594 13.2833 2.12683C13.3665 2.06437 13.5682 1.94699 13.8225 2.02697C14.0703 2.10491 14.1656 2.3079 14.1975 2.39943Z"
          fill="#2D70E2"
        />
      </g>
    </svg>
  );
}

export function ILIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <g id="Vector">
          <path
            d="M19.3111 17.0751C19.1214 17.0751 18.9617 17.0122 18.8319 16.8863C18.7021 16.7605 18.6372 16.6056 18.6372 16.4217V10.1932C18.6372 10.0093 18.7021 9.85447 18.8319 9.72864C18.9617 9.59313 19.1214 9.52538 19.3111 9.52538C19.5108 9.52538 19.6755 9.58829 19.8053 9.71412C19.9351 9.83995 20 9.99965 20 10.1932V16.4217C20 16.6056 19.9301 16.7605 19.7903 16.8863C19.6605 17.0122 19.5008 17.0751 19.3111 17.0751Z"
            fill={fill}
          />
          <path
            d="M18.8265 8.03815C18.9526 8.16048 19.1041 8.22165 19.2807 8.22165H19.3564C19.5331 8.22165 19.6845 8.16048 19.8107 8.03815C19.9369 7.91581 20 7.76901 20 7.59774V7.54881C20 7.37754 19.9369 7.23074 19.8107 7.10841C19.6845 6.98607 19.5331 6.9249 19.3564 6.9249H19.2807C19.1041 6.9249 18.9526 6.98607 18.8265 7.10841C18.7003 7.23074 18.6372 7.37754 18.6372 7.54881V7.59774C18.6372 7.76901 18.7003 7.91581 18.8265 8.03815Z"
            fill={fill}
          />
          <path
            d="M4.68889 6.92805C4.87859 6.92805 5.03833 6.99092 5.16812 7.11666C5.29791 7.2424 5.36281 7.39715 5.36281 7.58093V13.805C5.36281 13.9888 5.29791 14.1435 5.16812 14.2693C5.03833 14.4047 4.87859 14.4724 4.68889 14.4724C4.48921 14.4724 4.32448 14.4095 4.19469 14.2838C4.06489 14.1581 4 13.9985 4 13.805V7.58093C4 7.39715 4.06989 7.2424 4.20966 7.11666C4.33945 6.99092 4.4992 6.92805 4.68889 6.92805Z"
            fill={fill}
          />
          <path
            d="M5.17355 15.9594C5.04736 15.8372 4.89593 15.7761 4.71927 15.7761H4.64356C4.4669 15.7761 4.31547 15.8372 4.18929 15.9594C4.0631 16.0817 4 16.2284 4 16.3995V16.4484C4 16.6196 4.0631 16.7663 4.18929 16.8885C4.31547 17.0108 4.4669 17.0719 4.64356 17.0719H4.71927C4.89593 17.0719 5.04736 17.0108 5.17355 16.8885C5.29974 16.7663 5.36283 16.6196 5.36283 16.4484V16.3995C5.36283 16.2284 5.29974 16.0817 5.17355 15.9594Z"
            fill={fill}
          />
          <path
            d="M14.9786 4.9657C14.9786 4.60086 15.2836 4.3051 15.66 4.3051C16.0363 4.3051 16.3414 4.60086 16.3414 4.9657V19.0343C16.3414 19.3991 16.0363 19.6949 15.66 19.6949C15.2836 19.6949 14.9786 19.3991 14.9786 19.0343V4.9657Z"
            fill={fill}
          />
          <path
            d="M7.66131 4.9657C7.66131 4.60086 7.96638 4.3051 8.34271 4.3051C8.71904 4.3051 9.02412 4.60086 9.02412 4.9657V19.0343C9.02412 19.3991 8.71904 19.6949 8.34271 19.6949C7.96638 19.6949 7.66131 19.3991 7.66131 19.0343V4.9657Z"
            fill={fill}
          />
          <path
            d="M11.3199 3.6606C11.3199 3.29576 11.625 3 12.0013 3C12.3777 3 12.6827 3.29576 12.6827 3.6606V10.6876C12.6827 11.0525 12.3777 11.3482 12.0013 11.3482C11.625 11.3482 11.3199 11.0525 11.3199 10.6876V3.6606Z"
            fill={fill}
          />
          <path
            d="M11.3199 13.3124C11.3199 12.9475 11.625 12.6518 12.0013 12.6518C12.3777 12.6518 12.6827 12.9475 12.6827 13.3124V20.3394C12.6827 20.7042 12.3777 21 12.0013 21C11.625 21 11.3199 20.7042 11.3199 20.3394V13.3124Z"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
}

export function ChevronIcon(fill) {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 13L7 7L1 1" stroke="#666D79" strokeLinecap="round" />
    </svg>
  );
}

export function ChevronDownIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Path 3 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.64645 9.64062C7.84171 9.45313 8.15829 9.45313 8.35355 9.64062L12 13.142L15.6464 9.64062C15.8417 9.45313 16.1583 9.45313 16.3536 9.64062C16.5488 9.82812 16.5488 10.1321 16.3536 10.3196L12 14.5L7.64645 10.3196C7.45118 10.1321 7.45118 9.82812 7.64645 9.64062Z"
          fill="#666D79"
        />
      </g>
    </svg>
  );
}

export function ChevronUpIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Path 3 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.3536 14.3594C16.1583 14.5469 15.8417 14.5469 15.6464 14.3594L12 10.858L8.35355 14.3594C8.15829 14.5469 7.84171 14.5469 7.64645 14.3594C7.45118 14.1719 7.45118 13.8679 7.64645 13.6804L12 9.5L16.3536 13.6804C16.5488 13.8679 16.5488 14.1719 16.3536 14.3594Z"
          fill="#666D79"
        />
      </g>
    </svg>
  );
}


export function UserAvatar(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Stroke 1 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.39033 5.56245C8.82476 6.26949 8.5 7.38691 8.5 9C8.5 11.3784 9.20596 12.5161 9.75911 13.1799C9.88498 13.3309 10.0046 13.4593 10.1195 13.5827C10.1375 13.602 10.1553 13.6212 10.173 13.6402C10.2948 13.7714 10.4316 13.9204 10.53 14.0734C10.6329 14.2336 10.7319 14.4555 10.697 14.7244C10.6632 14.9852 10.516 15.1911 10.3536 15.3536C9.79738 15.9097 9.11646 16.3133 8.44236 16.6503C8.10429 16.8194 7.75972 16.9756 7.42895 17.1254L7.4213 17.1288C7.09015 17.2788 6.77365 17.4222 6.47361 17.5722C5.86371 17.8772 5.3703 18.1869 5.02853 18.5681C4.70175 18.9326 4.5 19.3773 4.5 20C4.5 20.2761 4.27614 20.5 4 20.5C3.72386 20.5 3.5 20.2761 3.5 20C3.5 19.1227 3.79825 18.4424 4.28397 17.9006C4.7547 17.3756 5.38629 16.9978 6.02639 16.6778C6.34375 16.5191 6.67518 16.369 7.00013 16.2218L7.01636 16.2145C7.34965 16.0635 7.67696 15.915 7.99514 15.7559C8.63354 15.4367 9.20262 15.0903 9.64645 14.6464C9.66218 14.6307 9.67437 14.6174 9.68374 14.6064C9.64067 14.5416 9.56727 14.4575 9.44024 14.3207C9.42405 14.3033 9.4072 14.2852 9.38978 14.2665C9.27529 14.1436 9.13582 13.994 8.99089 13.8201C8.29404 12.9839 7.5 11.6216 7.5 9C7.5 7.28009 7.84174 5.89751 8.60942 4.9378C9.39416 3.95677 10.5561 3.5 12 3.5C13.4439 3.5 14.6058 3.95677 15.3906 4.9378C16.1583 5.89751 16.5 7.28009 16.5 9C16.5 11.6216 15.706 12.9839 15.0091 13.8201C14.8642 13.994 14.7247 14.1437 14.6102 14.2665C14.5928 14.2852 14.5759 14.3033 14.5598 14.3207C14.4327 14.4575 14.3593 14.5416 14.3163 14.6064C14.3256 14.6174 14.3378 14.6307 14.3536 14.6464C14.7974 15.0903 15.3665 15.4367 16.0049 15.7559C16.323 15.915 16.6503 16.0635 16.9836 16.2145L16.9999 16.2218C17.3248 16.369 17.6563 16.5191 17.9736 16.6778C18.6137 16.9978 19.2453 17.3756 19.716 17.9006C20.2018 18.4424 20.5 19.1227 20.5 20C20.5 20.2761 20.2761 20.5 20 20.5C19.7239 20.5 19.5 20.2761 19.5 20C19.5 19.3773 19.2982 18.9326 18.9715 18.5681C18.6297 18.1869 18.1363 17.8772 17.5264 17.5722C17.2263 17.4222 16.9098 17.2788 16.5787 17.1288L16.571 17.1254C16.2403 16.9756 15.8957 16.8194 15.5576 16.6503C14.8835 16.3133 14.2026 15.9097 13.6464 15.3536C13.484 15.1911 13.3368 14.9852 13.303 14.7244C13.2681 14.4555 13.3671 14.2336 13.47 14.0734C13.5684 13.9204 13.7052 13.7714 13.827 13.6402C13.8447 13.6211 13.8625 13.602 13.8805 13.5827C13.9954 13.4593 14.115 13.3309 14.2409 13.1799C14.794 12.5161 15.5 11.3784 15.5 9C15.5 7.38691 15.1752 6.26949 14.6097 5.56245C14.0612 4.87673 13.2231 4.5 12 4.5C10.7769 4.5 9.93884 4.87673 9.39033 5.56245ZM14.2913 14.6498C14.2913 14.6498 14.2913 14.6497 14.2915 14.6493Z"
          fill="#2D70E2"
        />
      </g>
    </svg>
  );
}

export function CloseIcon(fill) {
  return (
    <svg
      width="59"
      height="20"
      viewBox="0 0 59 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.12049 5.11854C5.27907 4.95997 5.53616 4.95997 5.69474 5.11854L14.8826 14.3064C15.0412 14.465 15.0412 14.7221 14.8826 14.8807C14.7241 15.0393 14.467 15.0393 14.3084 14.8807L5.12049 5.69278C4.96192 5.53421 4.96192 5.27711 5.12049 5.11854Z"
        fill="#666D79"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.8826 5.11854C15.0412 5.27711 15.0412 5.53421 14.8826 5.69278L5.69474 14.8807C5.53616 15.0393 5.27907 15.0393 5.12049 14.8807C4.96192 14.7221 4.96192 14.465 5.12049 14.3064L14.3084 5.11854C14.467 4.95997 14.7241 4.95997 14.8826 5.11854Z"
        fill="#666D79"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.01443 5.01247C5.23158 4.79532 5.58365 4.79532 5.8008 5.01247L10.0016 9.21323L14.2023 5.01247C14.4195 4.79532 14.7715 4.79532 14.9887 5.01247C15.2059 5.22962 15.2059 5.5817 14.9887 5.79885L10.7879 9.99961L14.9887 14.2004C15.2058 14.4175 15.2059 14.7696 14.9887 14.9867C14.7715 15.2039 14.4195 15.2039 14.2023 14.9867L10.0016 10.786L5.8008 14.9867C5.58365 15.2039 5.23158 15.2039 5.01443 14.9867C4.79727 14.7696 4.79728 14.4175 5.01443 14.2004L9.21519 9.99961L5.01443 5.79885C4.79727 5.5817 4.79727 5.22962 5.01443 5.01247ZM9.42732 10.2117L5.22656 14.4125C5.12656 14.5125 5.12656 14.6746 5.22656 14.7746C5.32655 14.8746 5.48868 14.8746 5.58867 14.7746L9.78943 10.5739L9.42732 10.2117ZM10.0016 10.3617L9.63945 9.99961L10.0016 9.6375L10.3637 9.99961L10.0016 10.3617ZM10.2137 10.5739L14.4145 14.7746C14.5144 14.8746 14.6766 14.8746 14.7766 14.7746C14.8766 14.6746 14.8766 14.5125 14.7766 14.4125L10.5758 10.2117L10.2137 10.5739ZM10.5758 9.78748L14.7766 5.58672C14.8766 5.48672 14.8766 5.3246 14.7766 5.22461C14.6766 5.12461 14.5144 5.12461 14.4145 5.22461L10.2137 9.42537L10.5758 9.78748ZM9.78943 9.42537L9.42732 9.78748L5.22656 5.58672C5.12656 5.48672 5.12656 5.3246 5.22656 5.22461C5.32655 5.12461 5.48868 5.12461 5.58867 5.22461L9.78943 9.42537Z"
        fill="#666D79"
      />
      <path
        d="M24.49 9.46C24.49 8.85333 24.5973 8.26067 24.812 7.682C25.0267 7.094 25.3393 6.562 25.75 6.086C26.17 5.60067 26.6787 5.218 27.276 4.938C27.8733 4.64867 28.55 4.504 29.306 4.504C30.202 4.504 30.9767 4.70933 31.63 5.12C32.2833 5.52133 32.7687 6.03933 33.086 6.674L31.854 7.5C31.6673 7.09867 31.4293 6.78133 31.14 6.548C30.86 6.31467 30.552 6.15133 30.216 6.058C29.8893 5.96467 29.5673 5.918 29.25 5.918C28.7273 5.918 28.27 6.02533 27.878 6.24C27.486 6.44533 27.1547 6.72067 26.884 7.066C26.6227 7.41133 26.422 7.79867 26.282 8.228C26.1513 8.65733 26.086 9.08667 26.086 9.516C26.086 9.992 26.1653 10.454 26.324 10.902C26.4827 11.3407 26.702 11.7327 26.982 12.078C27.2713 12.414 27.612 12.68 28.004 12.876C28.396 13.072 28.8253 13.17 29.292 13.17C29.6093 13.17 29.9407 13.114 30.286 13.002C30.6313 12.89 30.9487 12.7173 31.238 12.484C31.5367 12.2413 31.77 11.924 31.938 11.532L33.24 12.274C33.0347 12.7687 32.7127 13.1887 32.274 13.534C31.8447 13.8793 31.3593 14.1407 30.818 14.318C30.286 14.4953 29.7587 14.584 29.236 14.584C28.536 14.584 27.8967 14.4393 27.318 14.15C26.7393 13.8513 26.24 13.4593 25.82 12.974C25.4 12.4793 25.0733 11.9287 24.84 11.322C24.6067 10.706 24.49 10.0853 24.49 9.46ZM34.5503 4.28H36.0903V14.5C36.0903 14.5 36.0343 14.5 35.9223 14.5C35.8196 14.5 35.6843 14.5 35.5163 14.5C35.3576 14.5 35.1896 14.5 35.0123 14.5C34.8443 14.5 34.6903 14.5 34.5503 14.5V4.28ZM41.3123 14.64C40.743 14.64 40.225 14.542 39.7583 14.346C39.301 14.1407 38.9043 13.8653 38.5683 13.52C38.2323 13.1653 37.971 12.764 37.7843 12.316C37.607 11.8587 37.5183 11.3733 37.5183 10.86C37.5183 10.1693 37.677 9.53933 37.9943 8.97C38.3116 8.39133 38.755 7.92933 39.3243 7.584C39.8936 7.22933 40.561 7.052 41.3263 7.052C42.0916 7.052 42.7496 7.22933 43.3003 7.584C43.8603 7.92933 44.2943 8.38667 44.6023 8.956C44.9103 9.52533 45.0643 10.1367 45.0643 10.79C45.0643 10.902 45.0596 11.0093 45.0503 11.112C45.041 11.2053 45.0316 11.2847 45.0223 11.35H39.1563C39.1843 11.7793 39.301 12.1573 39.5063 12.484C39.721 12.8013 39.9916 13.0533 40.3183 13.24C40.645 13.4173 40.995 13.506 41.3683 13.506C41.779 13.506 42.1663 13.4033 42.5303 13.198C42.9036 12.9927 43.1556 12.722 43.2863 12.386L44.6023 12.764C44.4436 13.1187 44.201 13.4407 43.8743 13.73C43.557 14.01 43.179 14.234 42.7403 14.402C42.3016 14.5607 41.8256 14.64 41.3123 14.64ZM39.1143 10.328H43.5383C43.5103 9.908 43.389 9.53933 43.1743 9.222C42.969 8.89533 42.703 8.64333 42.3763 8.466C42.059 8.27933 41.7043 8.186 41.3123 8.186C40.9296 8.186 40.575 8.27933 40.2483 8.466C39.931 8.64333 39.6696 8.89533 39.4643 9.222C39.259 9.53933 39.1423 9.908 39.1143 10.328ZM50.8565 14.5V13.436C50.5578 13.8467 50.1798 14.15 49.7225 14.346C49.2652 14.542 48.7798 14.64 48.2665 14.64C47.7998 14.64 47.3752 14.542 46.9925 14.346C46.6192 14.1407 46.3252 13.8653 46.1105 13.52C45.8958 13.1653 45.7885 12.7733 45.7885 12.344C45.7885 11.9613 45.8725 11.6253 46.0405 11.336C46.2178 11.0467 46.4512 10.804 46.7405 10.608C47.0298 10.412 47.3612 10.2673 47.7345 10.174C48.1078 10.0807 48.4905 10.034 48.8825 10.034C49.3118 10.034 49.6945 10.0713 50.0305 10.146C50.3665 10.2113 50.6278 10.286 50.8145 10.37V9.866C50.8145 9.334 50.6558 8.914 50.3385 8.606C50.0305 8.298 49.5918 8.144 49.0225 8.144C48.6398 8.144 48.2572 8.214 47.8745 8.354C47.4918 8.494 47.0998 8.704 46.6985 8.984L46.2225 8.004C46.6518 7.71467 47.1138 7.486 47.6085 7.318C48.1032 7.14067 48.6212 7.052 49.1625 7.052C49.8532 7.052 50.4318 7.17333 50.8985 7.416C51.3745 7.64933 51.7338 7.99467 51.9765 8.452C52.2285 8.9 52.3545 9.42733 52.3545 10.034V14.5H50.8565ZM50.5205 12.736C50.7165 12.5493 50.8145 12.372 50.8145 12.204V11.238C50.5438 11.1353 50.2592 11.056 49.9605 11C49.6712 10.944 49.3912 10.916 49.1205 10.916C48.8965 10.916 48.6725 10.944 48.4485 11C48.2245 11.0467 48.0192 11.126 47.8325 11.238C47.6552 11.3407 47.5105 11.476 47.3985 11.644C47.2958 11.8027 47.2445 11.994 47.2445 12.218C47.2445 12.47 47.3098 12.694 47.4405 12.89C47.5805 13.086 47.7578 13.24 47.9725 13.352C48.1872 13.4547 48.4252 13.506 48.6865 13.506C48.9105 13.506 49.1392 13.478 49.3725 13.422C49.6058 13.366 49.8252 13.282 50.0305 13.17C50.2358 13.058 50.3992 12.9133 50.5205 12.736ZM58.2295 8.508C57.6321 8.51733 57.1001 8.65267 56.6335 8.914C56.1761 9.17533 55.8495 9.544 55.6535 10.02V14.5H54.1135V7.178H55.5415V8.816C55.7935 8.312 56.1248 7.91067 56.5355 7.612C56.9461 7.304 57.3801 7.136 57.8375 7.108C57.9308 7.108 58.0055 7.108 58.0615 7.108C58.1268 7.108 58.1828 7.11267 58.2295 7.122V8.508Z"
        fill="#666D79"
      />
    </svg>
  );
}


export function AiIcon(fill) {
  return (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1389 18.7668C18.9017 18.7668 18.7021 18.6829 18.5398 18.5151C18.3776 18.3473 18.2965 18.1409 18.2965 17.8956V9.59098C18.2965 9.34577 18.3776 9.13929 18.5398 8.97152C18.7021 8.79084 18.9017 8.7005 19.1389 8.7005C19.3885 8.7005 19.5944 8.78439 19.7566 8.95216C19.9189 9.11993 20 9.33287 20 9.59098V17.8956C20 18.1409 19.9126 18.3473 19.7379 18.5151C19.5757 18.6829 19.376 18.7668 19.1389 18.7668Z"
        fill="white"
      />
      <path
        d="M18.5331 6.71753C18.6908 6.88064 18.8801 6.9622 19.1009 6.9622H19.1956C19.4164 6.9622 19.6057 6.88064 19.7634 6.71753C19.9211 6.55442 20 6.35868 20 6.13033V6.06508C20 5.83672 19.9211 5.64099 19.7634 5.47787C19.6057 5.31476 19.4164 5.23321 19.1956 5.23321H19.1009C18.8801 5.23321 18.6908 5.31476 18.5331 5.47787C18.3753 5.64099 18.2965 5.83672 18.2965 6.06508V6.13033C18.2965 6.35868 18.3753 6.55442 18.5331 6.71753Z"
        fill="white"
      />
      <path
        d="M0.861115 5.2374C1.09823 5.2374 1.29791 5.32122 1.46015 5.48888C1.62239 5.65653 1.70351 5.86287 1.70351 6.1079V14.4067C1.70351 14.6517 1.62239 14.8581 1.46015 15.0257C1.29791 15.2063 1.09823 15.2965 0.861115 15.2965C0.611516 15.2965 0.405596 15.2127 0.243357 15.0451C0.0811174 14.8774 0 14.6646 0 14.4067V6.1079C0 5.86287 0.0873585 5.65653 0.262078 5.48888C0.424317 5.32122 0.623996 5.2374 0.861115 5.2374Z"
        fill="white"
      />
      <path
        d="M1.46693 17.2792C1.3092 17.1162 1.11992 17.0347 0.89909 17.0347H0.804451C0.583623 17.0347 0.394341 17.1162 0.236607 17.2792C0.0788722 17.4422 5.03191e-06 17.6378 5.03191e-06 17.866V17.9312C5.03191e-06 18.1594 0.0788722 18.355 0.236607 18.518C0.394341 18.681 0.583623 18.7625 0.804451 18.7625H0.89909C1.11992 18.7625 1.3092 18.681 1.46693 18.518C1.62467 18.355 1.70354 18.1594 1.70354 17.9312V17.866C1.70354 17.6378 1.62467 17.4422 1.46693 17.2792Z"
        fill="white"
      />
      <path
        d="M13.7232 2.62093C13.7232 2.13448 14.1046 1.74013 14.575 1.74013C15.0454 1.74013 15.4267 2.13448 15.4267 2.62093V21.379C15.4267 21.8655 15.0454 22.2598 14.575 22.2598C14.1046 22.2598 13.7232 21.8655 13.7232 21.379V2.62093Z"
        fill="white"
      />
      <path
        d="M4.57663 2.62093C4.57663 2.13448 4.95798 1.74013 5.42839 1.74013C5.8988 1.74013 6.28015 2.13448 6.28015 2.62093V21.379C6.28015 21.8655 5.8988 22.2598 5.42839 22.2598C4.95798 22.2598 4.57663 21.8655 4.57663 21.379V2.62093Z"
        fill="white"
      />
      <path
        d="M9.1499 0.880798C9.1499 0.394347 9.53125 0 10.0017 0C10.4721 0 10.8534 0.394347 10.8534 0.880799V10.2502C10.8534 10.7366 10.4721 11.131 10.0017 11.131C9.53125 11.131 9.1499 10.7366 9.1499 10.2502V0.880798Z"
        fill="white"
      />
      <path
        d="M9.1499 13.7498C9.1499 13.2634 9.53125 12.869 10.0017 12.869C10.4721 12.869 10.8534 13.2634 10.8534 13.7498V23.1192C10.8534 23.6056 10.4721 24 10.0017 24C9.53125 24 9.1499 23.6056 9.1499 23.1192V13.7498Z"
        fill="white"
      />
    </svg>
  );
}

export function MiniILIcon(fill) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8715 11.3834C12.745 11.3834 12.6385 11.3414 12.552 11.2576C12.4654 11.1737 12.4222 11.0704 12.4222 10.9478V6.79549C12.4222 6.67289 12.4654 6.56964 12.552 6.48576C12.6385 6.39542 12.745 6.35025 12.8715 6.35025C13.0046 6.35025 13.1144 6.39219 13.2009 6.47608C13.2875 6.55996 13.3307 6.66643 13.3307 6.79549V10.9478C13.3307 11.0704 13.2841 11.1737 13.1909 11.2576C13.1044 11.3414 12.9979 11.3834 12.8715 11.3834Z"
        fill="#2D70E2"
      />
      <path
        d="M12.5484 5.35877C12.6325 5.44032 12.7334 5.4811 12.8512 5.4811H12.9017C13.0195 5.4811 13.1204 5.44032 13.2045 5.35877C13.2887 5.27721 13.3307 5.17934 13.3307 5.06516V5.03254C13.3307 4.91836 13.2887 4.82049 13.2045 4.73894C13.1204 4.65738 13.0195 4.6166 12.9017 4.6166H12.8512C12.7334 4.6166 12.6325 4.65738 12.5484 4.73894C12.4642 4.82049 12.4222 4.91836 12.4222 5.03254V5.06516C12.4222 5.17934 12.4642 5.27721 12.5484 5.35877Z"
        fill="#2D70E2"
      />
      <path
        d="M3.12332 4.6187C3.24979 4.6187 3.35628 4.66061 3.44281 4.74444C3.52934 4.82826 3.5726 4.93144 3.5726 5.05395V9.20334C3.5726 9.32586 3.52934 9.42903 3.44281 9.51286C3.35628 9.60313 3.24979 9.64827 3.12332 9.64827C2.9902 9.64827 2.88038 9.60636 2.79385 9.52253C2.70733 9.4387 2.66406 9.33231 2.66406 9.20334V5.05395C2.66406 4.93144 2.71065 4.82826 2.80384 4.74444C2.89036 4.66061 2.99686 4.6187 3.12332 4.6187Z"
        fill="#2D70E2"
      />
      <path
        d="M3.44643 10.6396C3.3623 10.5581 3.26135 10.5174 3.14358 10.5174H3.0931C2.97533 10.5174 2.87438 10.5581 2.79025 10.6396C2.70613 10.7211 2.66407 10.8189 2.66407 10.933V10.9656C2.66407 11.0797 2.70613 11.1775 2.79025 11.259C2.87438 11.3405 2.97533 11.3813 3.0931 11.3813H3.14358C3.26135 11.3813 3.3623 11.3405 3.44643 11.259C3.53055 11.1775 3.57262 11.0797 3.57262 10.9656V10.933C3.57262 10.8189 3.53055 10.7211 3.44643 10.6396Z"
        fill="#2D70E2"
      />
      <path
        d="M9.98311 3.31046C9.98311 3.06724 10.1865 2.87007 10.4374 2.87007C10.6883 2.87007 10.8916 3.06724 10.8916 3.31046V12.6895C10.8916 12.9327 10.6883 13.1299 10.4374 13.1299C10.1865 13.1299 9.98311 12.9327 9.98311 12.6895V3.31046Z"
        fill="#2D70E2"
      />
      <path
        d="M5.10493 3.31046C5.10493 3.06724 5.30832 2.87007 5.5592 2.87007C5.81009 2.87007 6.01347 3.06724 6.01347 3.31046V12.6895C6.01347 12.9327 5.81009 13.1299 5.5592 13.1299C5.30832 13.1299 5.10493 12.9327 5.10493 12.6895V3.31046Z"
        fill="#2D70E2"
      />
      <path
        d="M7.54401 2.4404C7.54401 2.19717 7.74739 2 7.99828 2C8.24917 2 8.45255 2.19717 8.45255 2.4404V7.12509C8.45255 7.36831 8.24917 7.56549 7.99828 7.56549C7.74739 7.56549 7.54401 7.36831 7.54401 7.12509V2.4404Z"
        fill="#2D70E2"
      />
      <path
        d="M7.54401 8.87491C7.54401 8.63169 7.74739 8.43451 7.99828 8.43451C8.24917 8.43451 8.45255 8.63169 8.45255 8.87491V13.5596C8.45255 13.8028 8.24917 14 7.99828 14C7.74739 14 7.54401 13.8028 7.54401 13.5596V8.87491Z"
        fill="#2D70E2"
      />
    </svg>
  );
}